import './styles/services.css';

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".services-list__list__item__link").forEach(item => {
        item.onclick = (e) => {
            e.preventDefault();
            const parent = e.currentTarget.parentElement.parentElement;
            document.querySelectorAll(".services-list__list__item__link").forEach(item => {
                if (item.parentElement.parentElement == parent) return;
                item.parentElement.parentElement.classList.remove("--selected");
            });
            parent.classList.toggle("--selected");
        }
    })

    document.querySelector('.services-list__searchbox').addEventListener('keyup', e => {
        filterServices(e.target.value.trim());
    });
});

function filterServices(serviceName) {
    const words = serviceName.toLowerCase().split(" ");
    if (words.length === 0) {
        document.querySelectorAll(".services-list__list__item").forEach(e => {
            e.style.display = 'none';
        });
        document.querySelector(".services-list__list__item.--empty").classList.add("--selected");
    } else {
        let serviceFound = false;
        document.querySelectorAll(".services-list__list__item").forEach(e => {
            if (!e.dataset.name) return;
            const elServiceName = e.dataset.name.toLowerCase();
            words.forEach(w => {
                const io = elServiceName.indexOf(w);
                if (io !== -1) {
                    e.style.display = 'block';
                    serviceFound = true;
                    return;
                } else {
                    e.style.display = 'none';
                }
            });
        });
        console.log({ serviceFound });
        if (!serviceFound) {
            document.querySelector(".services-list__list__item.--empty").classList.add("--selected");
        } else {
            document.querySelector(".services-list__list__item.--empty").classList.remove("--selected");
        }
    }
}